import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Col, Form, Row } from "react-bootstrap";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomTextArea from "../../../CustomControls/CustomTextArea";
import swal from "sweetalert";
import { Spin } from "antd";
import { post } from "../../../helpers/api_helper";
import {
  POST_DepartmentInsert,
  POST_DepartmentUpdate,
  POST_GetDepartmentDetailsByID,
  POST_ValidateLicenseLimit,
} from "../../../helpers/url_helper";
import {
  capitalizeString,
  errorMessage,
  successMessage,
} from "../CommonFunctions";

const AddDepartment = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const { PrimaryIdParam } = useParams();

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const validationSchema = Yup.object().shape({
    DepartmentName: Yup.string()
      .trim()
      .required("Department Name is required field"),
    Description: Yup.string(),
  });

  const formik = useFormik({
    validationSchema: validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      DepartmentIDEncrypted: PrimaryIdParam ? window.atob(PrimaryIdParam) : "",
      DepartmentName: "",
      Description: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {},
  } = formik;

  const handleValidSubmit = (values) => {
    setIsLoading(true);
    let payload = {
      ...values,
      DepartmentName: values.DepartmentName.trim(),
      Description: values.Description.trim(),
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
      ModifiedByEncrypted: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
    };
    post(
      PrimaryIdParam ? POST_DepartmentUpdate : POST_DepartmentInsert,
      payload
    )
      .then((response) => {
        setIsLoading(true);
        if (response.IsSuccess) {
          //swal("Success!", response.Message, "success");
          successMessage(response?.Message);
          setTimeout(() => {
            navigate("/departments");
          }, 1000);
        } else {
          //swal("Error!", response.Message, "error");
          errorMessage(response?.Message);
          setIsLoading(false);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (PrimaryIdParam) {
      get_DepartmentByID();
    } else {
      validateLicenseLimit();
    }
  }, []);

  const validateLicenseLimit = async () => {
    setIsLoading(true);
    await post(POST_ValidateLicenseLimit, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      LoginIDEncrypted: AuthUser?.LoginIDEncrypt,
      FormNo: 18, //Departments
    })
      .then((response) => {
        if (response?.IsSuccess == false) {
          // navigate("/departments");
          navigate(-1);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const get_DepartmentByID = async () => {
    setIsLoading(true);
    await post(POST_GetDepartmentDetailsByID, {
      DepartmentIDEncrypted: window.atob(PrimaryIdParam),
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setValues({
            ...response,
          });
        } else {
          // swal("Error!", response.Message, "error");
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="tbl-caption p-2">
            <h4 className="heading mb-0">
              {PrimaryIdParam ? "Edit" : "Add"} Department
            </h4>
          </div>
          <hr className="mt-0 mb-1"></hr>
          <div className="p-2 pt-0">
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col lg={6}>
                    <Field
                      type="text"
                      label={"Department Name"}
                      name="DepartmentName"
                      placeholder={"Enter Department Name"}
                      component={CustomInput}
                      maxLength={200}
                      required
                      autoFocus
                      onChange={(e) => {
                        formik.setFieldValue(
                          "DepartmentName",
                          capitalizeString(e)
                        );
                      }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={6}>
                    <Field
                      type="text"
                      label="Description"
                      name="Description"
                      placeholder={"Enter Description"}
                      component={CustomTextArea}
                      maxLength={200}
                      rows={5}
                    />
                  </Col>
                </Row>
                <hr className="mt-1 mb-2"></hr>
                <button
                  type="submit"
                  // className="btn btn-primary"
                  className="btn btn-primary btn-sm me-2"
                >
                  <i className="fa-solid fa-floppy-disk"></i> Submit
                </button>
                <button
                  type="button"
                  // className="btn btn-danger light"
                  className="btn btn-danger btn-sm"
                  onClick={(e) => {
                    navigate(-1);
                  }}
                >
                  <i className="fa fa-cancel"></i> Cancel
                </button>
              </Form>
            </FormikProvider>
          </div>
        </Spin>
      </div>
    </div>
  );
};

export default AddDepartment;
